"use strict";
var Observable_1 = require('../../Observable');
var subscribeOn_1 = require('../../operator/subscribeOn');
Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
//# sourceMappingURL=subscribeOn.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/rxjs/add/operator/subscribeOn.js
// module id = ../../../../rxjs/add/operator/subscribeOn.js
// module chunks = 4